import { useCallback } from "react";
import stencilStore from "../stores/stencilStore";
import { getStencilData } from "../services/stencilService";

export function useStencils() {
  const { stencils, setStencils } = stencilStore();

  const getStencils = useCallback(async () => {
    try {
      const data = await getStencilData();

      setStencils(data.stencils);
      return data;
    } catch (error) {
      console.error(`Failed to load stencils:`, error);
      return [];
    }
  }, [setStencils]);

  // Clear selected stencil statuses on stencils
  const clearSelectedStatuses = () => {
    const filtered = stencils.map((stencil) => {
      return {
        ...stencil,
        isSelectedWeek1: 0,
        isSelectedWeek2: 0,
        isSelectedWeek3: 0,
      };
    });

    setStencils(filtered);
  };

  return {
    stencils,
    setStencils,
    getStencils,
    clearSelectedStatuses,
  };
}
